import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Footer from './Footer.tsx';
import { getActiveTheme } from '../../config/seasonalThemes.ts';

interface AppLayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

const imgMask = 'linear-gradient(to top, black 0%, black 48%, rgba(0,0,0,0.6) 65%, transparent 84%)';

const SRCS = [
  { src: '/assets/easter/grass1.png', h: 155 },
  { src: '/assets/easter/grass3.png', h: 138 },
  { src: '/assets/easter/grass2.png', h: 150 },
];

// Espacement irrégulier en px pour un rendu naturel
const GAPS = [215, 255, 230, 270, 225, 260, 240, 250];

// Pré-génère ~20 plantes avec image et espacement aléatoires (calculé 1× au chargement)
const MEADOW_PLANTS = (() => {
  const list: { src: string; h: number; x: number }[] = [];
  let x = -25;
  let g = 0;
  while (x < 4800) {
    const s = SRCS[Math.floor(Math.random() * SRCS.length)];
    const hVar = Math.round((Math.random() - 0.5) * 16); // ±8px
    list.push({ src: s.src, h: s.h + hVar, x });
    x += GAPS[g % GAPS.length] + Math.round((Math.random() - 0.5) * 30);
    g++;
  }
  return list;
})();

const EasterMeadow: React.FC = () => (
  <div
    aria-hidden="true"
    style={{
      width: '100%',
      height: '160px',
      position: 'relative',
      overflow: 'hidden',
      pointerEvents: 'none',
      flexShrink: 0,
    }}
  >
    {/* Herbe de base — même échelle que les plantes décoratives */}
    <div style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: 'url(/assets/easter/grass0.png)',
      backgroundRepeat: 'repeat-x',
      backgroundPosition: 'bottom left',
      backgroundSize: 'auto 150px',
      maskImage: imgMask,
      WebkitMaskImage: imgMask,
    }} />
    {/* Plantes décoratives aléatoires par dessus */}
    {MEADOW_PLANTS.map(({ src, h, x }) => (
      <img
        key={x}
        src={src}
        alt=""
        style={{
          position: 'absolute',
          left: x,
          bottom: 0,
          height: `${h}px`,
          width: 'auto',
          maskImage: imgMask,
          WebkitMaskImage: imgMask,
        }}
      />
    ))}
  </div>
);

const AppLayout: React.FC<AppLayoutProps> = ({ children, showFooter = true }) => {
  const theme = getActiveTheme();
  return (
    <Flex direction="column" minH="100vh">
      <Box flex="1">
        {children}
      </Box>
      {theme?.id === 'easter' && <EasterMeadow />}
      {showFooter && <Footer />}
    </Flex>
  );
};

export default AppLayout;
